import { useRef, useEffect, useState } from 'react';

const PUBLIC_MERCHANT_ID = process.env.REACT_APP_KUSHKI_PUBLIC_MERCHANT_ID;
const IN_TEST_ENVIRONMENT = process.env.REACT_APP_KUSHKI_IN_TEST_ENVIRONMENT;

export const useKushki = () => {
  const kushkiRef = useRef(null);
  const intervalRef = useRef(null);
  const [kushkiInstance, setKushkiInstance] = useState(null);

  useEffect(() => {
    // Si ya está inicializado, no hacer nada
    if (kushkiRef.current) {
      return;
    }

    const initializeKushki = () => {
      if (typeof window !== 'undefined' && window.Kushki) {
        try {
          const instance = new window.Kushki({
            merchantId: PUBLIC_MERCHANT_ID,
            inTestEnvironment: IN_TEST_ENVIRONMENT === 'true',
          });
          kushkiRef.current = instance;
          setKushkiInstance(instance);
          return true;
        } catch (error) {
          console.error('Error al inicializar Kushki:', error);
          return false;
        }
      }
      return false;
    };

    // Intentar inicializar inmediatamente si ya está disponible
    if (initializeKushki()) {
      return;
    }

    // Si no está disponible, observar hasta que lo esté
    let attempts = 0;
    const maxAttempts = 50; // Máximo 5 segundos (50 * 100ms)

    const checkKushki = () => {
      attempts++;
      
      if (initializeKushki()) {
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
      } else if (attempts >= maxAttempts) {
        console.warn('Kushki no se cargó después de múltiples intentos');
        if (intervalRef.current) {
          clearInterval(intervalRef.current);
          intervalRef.current = null;
        }
      }
    };

    // Verificar cada 100ms
    intervalRef.current = setInterval(checkKushki, 100);

    // Cleanup
    return () => {
      if (intervalRef.current) {
        clearInterval(intervalRef.current);
        intervalRef.current = null;
      }
    };
  }, []);

  return kushkiInstance;
};